import reportTitle from './ReportTitle';
import reportIntro from './ReportIntro';

export default [reportTitle, reportIntro];
